import { render, staticRenderFns } from "./DashboardCharts.vue?vue&type=template&id=67ef59f8&scoped=true"
import script from "./DashboardCharts.vue?vue&type=script&lang=js"
export * from "./DashboardCharts.vue?vue&type=script&lang=js"
import style0 from "./DashboardCharts.vue?vue&type=style&index=0&id=67ef59f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ef59f8",
  null
  
)

export default component.exports